export const StatusArr = [
  "Draft",
  "Submitted",
  "Approved",
  "Released",
  "Rejected",
  "SentToStores",
  "TakenDown",
  "ReSubmitted",
];

export const formatStatusLabel = (status) => {
  if (!status) return "";

  // Add space before capital letters (except the first character)
  return status.replace(/([a-z])([A-Z])/g, "$1 $2");
};

export const getStatusDisplayLabel = (status) => {
  return formatStatusLabel(status);
};

export const StatusBadgeClasses = {
  Released:
    "bg-emerald-500/15 text-emerald-700 hover:bg-emerald-500/25 border-emerald-200",
  Draft: "bg-gray-500/15 text-gray-700 hover:bg-gray-500/25 border-gray-200",
  Submitted:
    "bg-blue-500/15 text-blue-700 hover:bg-blue-500/25 border-blue-200",
  SentToStores:
    "bg-purple-500/15 text-purple-700 hover:bg-purple-500/25 border-purple-200",
  Rejected: "bg-red-500/15 text-red-700 hover:bg-red-500/25 border-red-200",
  TakenDown: "bg-black/15 text-black hover:bg-black/25 border-black",
  Pending:
    "bg-yellow-500/15 text-yellow-700 hover:bg-yellow-500/25 border-yellow-200",
  Approved: "bg-lime-500/15 text-lime-700 hover:bg-lime-500/25 border-lime-200",
};

export const StatusDotClasses = {
  Released: "bg-emerald-400",
  Draft: "bg-gray-400",
  Submitted: "bg-blue-400",
  SentToStores: "bg-purple-400",
  Rejected: "bg-red-400",
  TakenDown: "bg-black",
  Pending: "bg-yellow-400",
  Approved: "bg-lime-400",
};
